import { Heading, Separator } from '@ctct/payflow-ui';

import { FooterItems } from './components/FooterItems';
import { OrderItems } from './components/OrderItems';
import type { Props } from './types';

import './order-summary.scss';

export const OrderSummary = ({
  copies,
  orderItems,
  injectedMiddleComponent,
  footerItems,
  subfooterItems,
  hideHeading = false,
}: Props) => {
  const { heading } = copies;

  return (
    <div className="payflow-presentation order-summary-container">
      {!hideHeading && <Heading level="h6">{heading}</Heading>}
      <OrderItems orderItems={orderItems} />
      {injectedMiddleComponent}
      <Separator />
      <FooterItems footerItems={footerItems} />
      {subfooterItems?.length ? (
        <div className="order-summary__subfooter">
          <Separator />
          <FooterItems footerItems={subfooterItems} />
        </div>
      ) : null}
    </div>
  );
};
